<template>
    <b-card no-body class="overflow-hidden">
        <b-sidebar v-model="filtersPanel" right bg-variant="white" shadow>
            <seyir-actual-location-filter v-on:filter="filter($event)"></seyir-actual-location-filter>
        </b-sidebar>
        <b-sidebar v-model="panel" right bg-variant="white" shadow>
            <div class="p-2">
                <h1 class="font-weight-bolder border-bottom pb-50">{{$safe(currentVehicle,'Vehicle')}}</h1>
                <b-badge :variant="isCurrentVehicleRunning ? 'success':'danger'">{{isCurrentVehicleRunning ? 'Yolda' : 'Duruyor'}}</b-badge>  
                <table class="table table-sm mt-1">
                    <tbody>
                        <tr>
                            <td class="font-weight-bolder">Sahip</td>
                            <td class="text-right text-nowrap">{{$safe(currentVehicle,'Owner') || '-'}}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bolder">Sürücü</td>
                            <td class="text-right">{{$safe(currentVehicle,'Driver') || '-'}}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bolder">Hız</td>
                            <td class="text-right">{{$safe(currentVehicle,'Speed') || '-'}}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bolder">Latitude</td>
                            <td class="text-right">{{currentVehicleLatLng.Lat}}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bolder">Longitude</td>
                            <td class="text-right">{{currentVehicleLatLng.Lng}}</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bolder">Açı</td>
                            <td class="text-right">{{$safe(currentVehicle,'Angle') || '-'}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="border rounded mt-1 p-1">
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <h2 class="mb-0"><span class="d-block material-icons-outlined">my_location</span></h2>
                        </div>
                        <div class="col">
                            {{$safe(currentVehicle,'Address')}}
                        </div>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <button class="btn btn-primary filter-button d-flex align-items-center" v-on:click="showFilter">
            <feather-icon icon="FilterIcon" class="mr-50"></feather-icon>
            Filtrele
            <b-badge v-if="filterCount > 0" pill  class="ml-50">{{filterCount}}</b-badge>
        </button>
        <b-overlay :show="loading" opacity="0.5">
            <div ref="map" class="map w-100"></div>
        </b-overlay>
    </b-card>
</template>

<script>
import { BCard,BSidebar,BBadge,BOverlay } from 'bootstrap-vue'
import { ActualLocation } from './actual-location'
import SeyirApi from '@/api/seyir' 
import GoogleMaps from '@/utilities/google-maps'
import SeyirActualLocationFilter from './components/SeyitActualLocationFilter.vue'

export default {
    components:{
        BCard,
        BSidebar,
        BBadge,
        SeyirActualLocationFilter,
        BOverlay
    },
    data(){
        return{
            locations:[],
            loading:false,
            actualLocation:null,
            map:null,
            panel:false,
            filtersPanel:false,
            filterData:{
                GarageId:null,
                DutyFirmId:null,
                DutyFirmLocationId:null,
                IsVehicleRunning:null,
                Plate:null
            },
            currentVehicle:{}
        }
    },
    created(){
        this.actualLocation = new ActualLocation()
    },
    mounted(){
        this.configureMap().then(res=>{
            this.getActualLocations()
            this.actualLocation?.ConnectHub().then(()=>{
                this.actualLocation?.Listen((c)=>{
                    try {
                        const locations = JSON.parse(c)
                        this.locations = locations
                        this.setMarkers(locations)
                    } catch (error) { console.log('Connection Error',error) }
                })
            })
        })
    },
    methods:{
        filter(filterData){
            this.filterData = filterData
            this.getActualLocations()
        },
        getActualLocations(){
            this.loading = true
            SeyirApi.ActualLocation(this.filterData).then(res=>{
                this.locations = res.data.Data
                this.setMarkers(res.data.Data)
                this.loading = false
            }).catch(err=>{
                this.loading = false
            })
        },
        setMarkers(data){
            this.map.setMarkers(data,(e)=>{
                this.panel = true
                this.filtersPanel = false
                this.currentVehicle = e
            })
        },
        showFilter(){
            this.panel = false
            this.filtersPanel = true
        },
        configureMap(){
            return new Promise((resolve)=>{
                const google = new GoogleMaps()
                google.RenderMapWithMarkers(this.$refs.map).then(res=>{ 
                    this.map = res
                    resolve(true)
                })
            })
        },
    },
    computed:{
        isCurrentVehicleRunning(){
            return this.currentVehicle?.IsVehicleRunning == "1" ? true : false
        },
        currentVehicleLatLng(){
            return {
                Lat: Number(this.currentVehicle?.Latitude).toFixed(2) || '-',
                Lng: Number(this.currentVehicle?.Longitude).toFixed(2) || '-',
            }
        },
        filterCount(){
            let count = 0
            if(this.filterData.GarageId != null) count ++
            if(this.filterData.DutyFirmId != null) count ++
            if(this.filterData.DutyFirmLocationId != null) count ++
            if(this.filterData.IsVehicleRunning != null) count ++
            if(this.filterData.Plate != null && this.filterData.Plate != "") count ++
            return count
        }
    },
}
</script>

<style>
.map{
    height:calc(100vh - 12.25rem)
}
.filter-button{
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 999;
}
</style>